import { Card, CardBody, CardFooter, Image } from "@heroui/react";
import { ROUTES } from '~/constants/routes.contants';
import { BaseLink } from '~/components/atoms/Link';
import { ReadOnlyRating } from '~/components/molecules/ReadOnlyRating';
import { FollowButton } from '~/components/molecules/FollowButton';
import { FoodResponseDto } from '@bitecritic-api/src/foods/dto/food.response.dto';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { CountryFlag } from '~/components/atoms/CountryFlag';
import { titleAndIdToSlug } from '~/utils/slug-utils';
import NextImage from "next/image";
import { useLocale } from "~/hooks/useLocale";

export const FoodCard = ({ isDetailPage = false, data }: { isDetailPage?: boolean, data: FoodResponseDto }) => {
  const { t } = useTranslation();
  const { id, name, mainImageId, reviewCount, reviewOverallRating, country } = data;
  const [imgSrc, setImgSrc] = useState(mainImageId || '/images/empty.webp');
  const { navigateTo } = useLocale();
  const navigateLink = `${ROUTES.FOODS}/${titleAndIdToSlug(name, id.toString())}`;

  return (
    <Card className="hover:shadow-lg transition-shadow border border-content3">
      <BaseLink href={navigateLink} className="flex flex-col">
        <CardBody className="w-full h-[200px] max-h-[220px] p-0 block overflow-visible relative">
          <Image
            removeWrapper
            alt={name}
            src={imgSrc}
            onError={() => {
              if (imgSrc !== '/images/empty.webp') {
                setImgSrc('/images/empty.webp');
              }
            }}
            as={NextImage}
            fill
            className="w-full h-full absolute object-cover rounded-t-lg"
            priority={isDetailPage}
          />
          <ReadOnlyRating rating={reviewOverallRating} className="absolute top-2 right-2 z-10" />
        </CardBody>
        <CardFooter onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
          className="flex flex-col items-start gap-2 p-4">
          <div className="flex justify-between items-center w-full">
            <div className="flex items-center gap-2 w-80" onClick={() => {
              navigateTo(navigateLink);
            }}>
              {isDetailPage ? (
                <h1 className="text-lg font-semibold text-primary-600">{name}</h1>
              ) : (
                <h3 className="text-lg font-semibold text-primary-600">{name}</h3>
              )}
              {country && (
                <CountryFlag
                  countryCode={country.code}
                  countryName={country.name}
                  size="sm"
                />
              )}
            </div>
            <FollowButton foodId={id} />
          </div>
          <span className="text-sm text-secondary-500">{t('common.reviews_count', { count: reviewCount })}</span>
        </CardFooter>
      </BaseLink>
    </Card>
  );
}; 